import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { CaretDown, CheckCircle } from '@phosphor-icons/react';
import { isMobile, isTablet } from 'react-device-detect';

interface Props {
  children: React.ReactNode;
  icon: React.ReactNode;
  heading: string;
  subheading?: string | React.ReactNode;
  isComplete: boolean;
  isOpen: boolean;
  isDisabled?: boolean;
}

const MaAccordion: React.FC<Props> = (props) => {
  const {
    children,
    icon,
    heading,
    subheading,
    isComplete,
    isOpen,
    isDisabled,
  } = props;

  const [isExpanded, setIsExpanded] = useState(isOpen && !isDisabled);

  return (
    <Accordion
      className="w-full border border-grey-200 border-solid rounded-md"
      expanded={isExpanded}
      onChange={() => setIsExpanded(!isExpanded)}
      disableGutters
      sx={{ ':before': { display: 'none' } }}
      disabled={isDisabled}
    >
      <AccordionSummary
        expandIcon={<CaretDown weight="bold" size="1.2rem" />}
        className="items-start sm:items-center p-4 gap-1 sm:gap-4 cursor-pointer"
        sx={{ '.MuiAccordionSummary-content': { margin: '0' } }}
      >
        <div className="w-full flex items-start sm:items-center justify-between gap-2 sm:gap-4">
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              {icon}
              <div className="text-xl font-bold uppercase leading-none">
                {heading}
              </div>
            </div>

            {subheading && <div>{subheading}</div>}
          </div>

          {isComplete && !isDisabled && (
            <div className="flex items-center gap-1 text-success-900 font-semibold whitespace-nowrap">
              <CheckCircle weight="fill" size="1.2rem" />

              {!isMobile && !isTablet && <div>Complete</div>}
            </div>
          )}
        </div>
      </AccordionSummary>

      {children && !isDisabled && (
        <AccordionDetails className="flex flex-col pt-0 gap-6">
          {children}
        </AccordionDetails>
      )}
    </Accordion>
  );
};

export default MaAccordion;
